import './entry';
import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import Plugins from './plugins';
import Packages from './packages';
import Components from './components';

Vue.config.productionTip = false;

Vue.use(Plugins);
Vue.use(Packages);
Vue.use(Components);

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
